export enum TabKey {
    PLAN = 'plan',
    CREATE = 'create',
    EDIT = 'editor',
    PROJECT = 'project',
}

export enum CampaignTab {
    PLAN = 'plan',
    CREATE = 'create',
    PUBLISH = 'publish',
}

export enum Sort {
    DESC = 'desc',
    ASC = 'asc',
}

export const DAYS_MAP = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
